var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLoanPortfolioDetails = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  viewBox: "0 0 80 80",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-12,.cls-6{fill:none}.cls-1,.cls-2{clip-rule:evenodd}.cls-2{fill:rgba(0,0,0,0)}.cls-3{clip-path:url(#clip-path)}.cls-4{fill:#fff}.cls-5{clip-path:url(#clip-path-2)}.cls-12,.cls-6{stroke:#5f7278}.cls-6{stroke-width:4px}.cls-7{clip-path:url(#clip-path-3)}.cls-8{fill:#5f7278}.cls-9{clip-path:url(#clip-path-4)}.cls-10{clip-path:url(#clip-path-5)}.cls-11{clip-path:url(#clip-path-6)}.cls-12{stroke-width:.3px}\n        "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_67",
  d: "M0-24h80v80H0z",
  className: "cls-1",
  "data-name": "Path 67",
  transform: "translate(0 24)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_69",
  d: "M4 8.349A28.349 28.349 0 1 0 32.349-20 27.668 27.668 0 0 0 14.3-13.469",
  className: "cls-1",
  "data-name": "Path 69",
  transform: "translate(-4 20)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_71",
  d: "M10.082-13.405l7.835 8.021H2.247z",
  className: "cls-1",
  "data-name": "Path 71",
  transform: "translate(-3.247 13.405)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-4"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_73",
  d: "M12-21h3.335v6.67H12z",
  className: "cls-1",
  "data-name": "Path 73",
  transform: "translate(-12 21)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-5"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_75",
  d: "M12.668-22h6.67a1.668 1.668 0 0 1 1.668 1.668 1.668 1.668 0 0 1-1.668 1.668h-6.67A1.668 1.668 0 0 1 11-20.332 1.668 1.668 0 0 1 12.668-22z",
  className: "cls-1",
  "data-name": "Path 75",
  transform: "translate(-11 22)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-6"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_77",
  d: "M23.362 2.494A2.655 2.655 0 0 0 22.207.318a11.472 11.472 0 0 0-3.9-1.6 13.726 13.726 0 0 1-5.562-2.38A4.658 4.658 0 0 1 11-7.392a4.762 4.762 0 0 1 1.711-3.778 8.191 8.191 0 0 1 4.7-1.755V-16h2.669v3.089a7.58 7.58 0 0 1 4.684 1.98 6.092 6.092 0 0 1 1.675 4.536h-3.3a4.182 4.182 0 0 0-1.2-3.146 4.455 4.455 0 0 0-3.242-1.166 5.284 5.284 0 0 0-3.26.864 2.86 2.86 0 0 0-1.128 2.408A2.665 2.665 0 0 0 15.5-5.153a12.308 12.308 0 0 0 3.923 1.545 18.873 18.873 0 0 1 4.263 1.531A6.111 6.111 0 0 1 25.95-.132a4.639 4.639 0 0 1 .725 2.6 4.641 4.641 0 0 1-1.818 3.82A9.249 9.249 0 0 1 19.762 8v2.682h-2.651V8a8.767 8.767 0 0 1-5.221-1.862A5.5 5.5 0 0 1 10 1.736h3.314a3.636 3.636 0 0 0 1.308 3.005 5.775 5.775 0 0 0 3.708 1.053 6.651 6.651 0 0 0 3.69-.885 2.752 2.752 0 0 0 1.342-2.415z",
  className: "cls-2",
  "data-name": "Path 77",
  transform: "translate(-10 16)"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_110",
  "data-name": "Group 110",
  transform: "translate(0 24)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_102",
  className: "cls-3",
  "data-name": "Group 102",
  transform: "translate(0 -24)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_66",
  d: "M-5-29h113.333V84.333H-5z",
  className: "cls-4",
  "data-name": "Path 66",
  transform: "translate(-11.667 12.333)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_104",
  className: "cls-5",
  "data-name": "Group 104",
  transform: "translate(13.297 -10.703)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_103",
  "data-name": "Group 103",
  transform: "rotate(90 28.349 28.349)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_68",
  d: "M28.349 56.7A28.349 28.349 0 1 0 0 28.349 27.668 27.668 0 0 0 6.531 46.4",
  className: "cls-6",
  "data-name": "Path 68"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_105",
  className: "cls-7",
  "data-name": "Group 105",
  transform: "translate(7.495 11.314)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_70",
  d: "M-2.753-18.405h49.021v41.373H-2.753z",
  className: "cls-8",
  "data-name": "Path 70",
  transform: "translate(-13.923 1.729)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_106",
  className: "cls-9",
  "data-name": "Group 106",
  transform: "translate(39.999 -16.349)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_72",
  d: "M7-26h36.687v40.022H7z",
  className: "cls-8",
  "data-name": "Path 72",
  transform: "translate(-23.676 9.324)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_107",
  className: "cls-10",
  "data-name": "Group 107",
  transform: "translate(36.664 -17.33)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_74",
  d: "M6-27h43.357V9.687H6z",
  className: "cls-8",
  "data-name": "Path 74",
  transform: "translate(-22.676 10.324)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_108",
  className: "cls-11",
  "data-name": "Group 108",
  transform: "translate(33.329 2.659)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_76",
  d: "M5-21h50.027v60.033H5z",
  className: "cls-8",
  "data-name": "Path 76",
  transform: "translate(-21.676 4.324)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_109",
  "data-name": "Group 109",
  transform: "translate(33.329 2.659)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_78",
  d: "M13.362 18.494a2.655 2.655 0 0 0-1.155-2.177 11.472 11.472 0 0 0-3.9-1.6 13.725 13.725 0 0 1-5.562-2.38A4.658 4.658 0 0 1 1 8.608a4.762 4.762 0 0 1 1.714-3.777 8.191 8.191 0 0 1 4.7-1.755V0h2.669v3.089a7.58 7.58 0 0 1 4.684 1.98 6.092 6.092 0 0 1 1.675 4.536h-3.3a4.182 4.182 0 0 0-1.2-3.146 4.455 4.455 0 0 0-3.237-1.165 5.284 5.284 0 0 0-3.26.864 2.86 2.86 0 0 0-1.128 2.408 2.665 2.665 0 0 0 1.191 2.282 12.308 12.308 0 0 0 3.923 1.545 18.874 18.874 0 0 1 4.263 1.531 6.11 6.11 0 0 1 2.257 1.945 4.639 4.639 0 0 1 .725 2.6 4.641 4.641 0 0 1-1.818 3.82A9.249 9.249 0 0 1 9.762 24v2.682H7.111V24a8.767 8.767 0 0 1-5.221-1.862A5.5 5.5 0 0 1 0 17.736h3.314a3.636 3.636 0 0 0 1.308 3.005 5.775 5.775 0 0 0 3.708 1.053 6.651 6.651 0 0 0 3.69-.885 2.752 2.752 0 0 0 1.342-2.415z",
  className: "cls-12",
  "data-name": "Path 78"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLoanPortfolioDetails);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_loan_portfolio_details.b5dd8af0cb34381f65bcaecb4d5efe22.svg";